import { VaultMediaType } from '@api'

export const MEDIA_TYPE_OPTIONS = [
  {
    label: 'All',
    value: VaultMediaType.ALL,
  },
  {
    label: 'Photos',
    value: VaultMediaType.PHOTO,
  },
  {
    label: 'Videos',
    value: VaultMediaType.VIDEO,
  },
  {
    label: 'Audios',
    value: VaultMediaType.AUDIO,
  },
]
